import { useState } from "react";

const faqs = [
  {
    category: "Teilnahme",
    items: [
      {
        q: "Ist die Ziehung wirklich zertifiziert?",
        a: "Ja, jede Ziehung wird von einem unabhängigen Notar überwacht, der die Fairness und absolute Unparteilichkeit des Prozesses garantiert. Wir verfügen über eine offizielle Lizenz der GGL (Gemeinsame Glücksspielbehörde der Länder) seit dem 28. Juni 2024.",
      },
      {
        q: "Kann ich Lose aus dem Ausland kaufen?",
        a: "Ja! Unser Service ist aus allen Ländern der Europäischen Union zugänglich. Zahlungen werden in Euro über unsere sicheren Partner (PayPal, Visa, Mastercard, Klarna, SEPA) abgewickelt.",
      },
      {
        q: "Wie viele Lose kann ich kaufen?",
        a: "Sie können so viele Lose kaufen, wie Sie möchten, im Rahmen unserer verfügbaren Pakete. Je mehr Lose Sie kaufen, desto höher sind Ihre Gewinnchancen.",
      },
      {
        q: "Kann ich meine Bestellung stornieren?",
        a: "Gemäß unseren AGB sind Käufe von Lotterielosen nach der Zahlungsbestätigung endgültig. Im Falle eines Fehlers kontaktieren Sie bitte unseren Support innerhalb von 30 Minuten nach dem Kauf.",
      },
    ],
  },
  {
    category: "Gewinne & Zahlung",
    items: [
      {
        q: "Wie werde ich benachrichtigt, wenn ich gewinne?",
        a: "Sie werden innerhalb von 24 Stunden nach der Ziehung per E-Mail und Telefon kontaktiert. Stellen Sie sicher, dass Ihre E-Mail-Adresse und Telefonnummer in Ihrem Kontobereich auf dem neuesten Stand sind.",
      },
      {
        q: "Wie erhalte ich meinen Gewinn, wenn ich gewinne?",
        a: "Der Hauptgewinn (die Villa auf der Insel Föhr) wird persönlich mit notarieller Eigentumsübertragung übergeben. Geldgewinne werden innerhalb von 5 Werktagen auf Ihr hinterlegtes IBAN-Konto überwiesen.",
      },
      {
        q: "Muss ich Steuern auf meine Gewinne zahlen?",
        a: "In Deutschland sind Lotteriegewinne steuerfrei. Für Einwohner anderer Länder empfehlen wir, einen lokalen Steuerberater zu konsultieren, da die Regeln von Land zu Land variieren.",
      },
    ],
  },
  {
    category: "Konto & Technik",
    items: [
      {
        q: "Ich habe mein Passwort vergessen, was soll ich tun?",
        a: "Klicken Sie auf der Anmeldeseite auf \"Passwort vergessen\". Ein Link zum Zurücksetzen wird Ihnen innerhalb weniger Minuten per E-Mail zugesandt. Überprüfen Sie auch Ihren Spam-Ordner.",
      },
      {
        q: "Wie kann ich meine E-Mail-Adresse oder mein Passwort ändern?",
        a: "Gehen Sie in Ihren Bereich \"Mein Konto\" und dann zum Tab \"Einstellungen\". Dort können Sie alle Ihre persönlichen Informationen ändern.",
      },
      {
        q: "Sind meine persönlichen Daten sicher?",
        a: "Absolut. Wir verkaufen oder teilen Ihre Daten niemals. Alle Informationen werden verschlüsselt und gemäß der DSGVO gespeichert. Weitere Details finden Sie in unserer Datenschutzerklärung.",
      },
    ],
  },
];

export default function FaqAccordion() {
  const [openItem, setOpenItem] = useState<string | null>(null);

  const toggle = (key: string) => {
    setOpenItem(openItem === key ? null : key);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-yellow-500 text-xs font-bold tracking-[0.25em] uppercase">Häufig gestellte Fragen</span>
          <h2 className="font-playfair text-4xl font-bold text-slate-900 mt-3">FAQ</h2>
          <p className="text-slate-500 text-base mt-3">Hier finden Sie Antworten auf die am häufigsten gestellten Fragen.</p>
        </div>

        <div className="space-y-10">
          {faqs.map((section) => (
            <div key={section.category}>
              <h3 className="text-xs font-bold tracking-[0.2em] uppercase text-slate-400 mb-4 flex items-center gap-3">
                <span className="flex-1 h-px bg-slate-100"></span>
                {section.category}
                <span className="flex-1 h-px bg-slate-100"></span>
              </h3>
              <div className="space-y-2">
                {section.items.map((item, idx) => {
                  const key = `${section.category}-${idx}`;
                  const isOpen = openItem === key;
                  return (
                    <div
                      key={key}
                      className={`rounded-xl border transition-all duration-200 cursor-pointer ${
                        isOpen ? "border-yellow-200 bg-yellow-50/40" : "border-slate-100 bg-slate-50 hover:border-slate-200"
                      }`}
                      onClick={() => toggle(key)}
                    >
                      <div className="flex items-center justify-between gap-4 px-5 py-4">
                        <p className={`text-sm font-semibold leading-snug ${isOpen ? "text-slate-900" : "text-slate-700"}`}>
                          {item.q}
                        </p>
                        <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${isOpen ? "bg-yellow-400 text-slate-900" : "bg-white border border-slate-200 text-slate-500"}`}>
                          <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                        </div>
                      </div>
                      <div
                        className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-60" : "max-h-0"}`}
                      >
                        <p className="px-5 pb-5 text-sm text-slate-600 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
